import React, { useState } from 'react';

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';

const HomepageNavbar = ({selectedNav, navbarClicked}) => {
    console.log("selectedNav is '" + selectedNav + "'");

    return (
        <Navbar bg="dark" variant="dark" expand="lg">
            <Container>
                <Navbar.Brand href="https://www.rit.edu">RIT</Navbar.Brand>
                <Navbar.Toggle aria-controls="homepage-nav" />
                <Navbar.Collapse id="homepage-brands">
                    <Nav>
                        <Nav.Link href="https://www.rit.edu/online/programs/data-science-ms">Data Science</Nav.Link>
                        <Nav.Link href="https://www.rit.edu/computing/department-software-engineering">Software Engineering</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
                <Navbar.Collapse id="homepage-nav" className="justify-content-end">
                    <Nav className="me-auto" activeKey={selectedNav} onSelect={(selectedKey) => navbarClicked(selectedKey)}>
                        <Nav.Link href="#" eventKey="Travis Desell" >Travis Desell</Nav.Link>
                        <Nav.Link href="#" eventKey="D2S2 Lab" >D2S2 Lab</Nav.Link>
                        <Nav.Link href="#" eventKey="Publications" >Publications</Nav.Link>

                        <NavDropdown alignRight title="Research Projects" id="collasible-nav-dropdown">
                            <NavDropdown.Item href="https://github.com/travisdesell/exact">Neuroevolution with EXACT and EXAMM</NavDropdown.Item>
                            <NavDropdown.Item href="https://github.com/travisdesell/tao">The Toolkit for Asynchronous Optimization (TAO)</NavDropdown.Item>
                            <NavDropdown.Item href="https://github.com/travisdesell/ngafid2.0">The National General Aviation Flight Information Database (NGAFID)</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Header>Citizen Science Projects</NavDropdown.Header>
                            <NavDropdown.Item href="https://milkyway.cs.rpi.edu/milkyway/">Milkyway@Home</NavDropdown.Item>
                            <NavDropdown.Item href="http://neuroevolution.rit.edu/">Neuroevolution@Home</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default HomepageNavbar;

